import { tableState } from "../../types/table/table-state.type";

export const INITIAL_TABLE_STATE: tableState = {
    loading: true
};
